import axios from 'axios';
import { action, Module, mutation, VuexModule } from 'vuex-class-component';
import { vxm } from '@/store.vuex';
@Module({ namespacedPath: 'roleSignup/' })
export class RoleSignup extends VuexModule {
  private pilotLicenseCategories: Array<any> = [];
  private engineerLicenceCategories: Array<any> = [];
  private pilotFleetOptions: Array<any> = [];
  private engineerFleetOptions: Array<any> = [];
  private equipmentTypeOptions: Array<any> = [];
  private pilotRankOptions: Array<any> = [];
  private engineerRankOptions: Array<any> = [];
  private marketingEmail: boolean = false;
  private childCompanies: Array<any> = [];
  private customFieldMappings = {
    rank: '',
    fleet: '',
    hour: '',
    role: '',
    aircraftAirframe: '',
    equipmentType: '',
    lastFlightDate: '',
  };

  public async pioletSignup() {}
  public async engineerSignup() {}

  get PilotLicenseCategories() {
    return this.pilotLicenseCategories;
  }

  get EngineerLicenceCategories() {
    return this.engineerLicenceCategories;
  }

  get PilotFleetOptions() {
    return this.pilotFleetOptions;
  }

  get EngineerFleetOptions() {
    return this.engineerFleetOptions;
  }

  get PilotRankOptions() {
    return this.pilotRankOptions;
  }

  get EngineerRankOptions() {
    return this.engineerRankOptions;
  }

  get CustomFieldMappings() {
    return this.customFieldMappings;
  }

  get EquipmentTypeOptions() {
    return this.equipmentTypeOptions;
  }

  get ChildCompanies() {
    return this.childCompanies;
  }

  get MarketingEmail() {
    return this.marketingEmail;
  }

  @mutation
  public setMarketingMail(payload) {
    this.marketingEmail = payload;
  }

  @mutation
  public setPilotFleetOptions(payload) {
    this.pilotFleetOptions = payload;
  }

  @mutation
  public setEngineerFleetOptions(payload) {
    this.engineerFleetOptions = payload;
  }

  @mutation
  public setEquipmentTypeOptions(payload) {
    this.equipmentTypeOptions = payload;
  }

  @mutation
  public setPilotRankOptions(payload) {
    this.pilotRankOptions = payload;
  }

  @mutation
  public setEngineerRankOptions(payload) {
    this.engineerRankOptions = payload;
  }

  @mutation
  public setPilotLicenseCategories(payload) {
    this.pilotLicenseCategories = payload;
  }

  @mutation
  public setEngineerLicenceCategories(payload) {
    this.engineerLicenceCategories = payload;
  }

  @mutation
  public setCustomFieldMappings(payload) {
    this.customFieldMappings = payload;
  }

  @mutation
  public setChildCompanies(payload) {
    this.childCompanies = payload;
  }

  @action({ mode: 'mutate' })
  public async basicSignup(payload) {
    payload.companyCode = vxm.jobs.BrandingInfo.companycode;
    payload.userName = payload.email;
    payload.doNotTriggerEvent = 'true';
    const response = await axios.post(
      '/wl-sso-sec-svc/api/user/register',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    );
    if (response.data.jwt && response.data.jwt.accessToken) {
      vxm.users.setAuthStatus(true);
      vxm.users.setToken(response.data.jwt.accessToken.token);
      vxm.users.setRefreshToken(response.data.jwt.refreshToken.token);
    }
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async uploadResume(payload) {
    const resumePayload = JSON.stringify({
      resumename: '',
      jobpostingid: -1,
      resumeLink: '',
    });
    const formData = new FormData();
    var resumeName = payload.resume.resumename;
    if (resumeName && resumeName.includes("'")) {
      resumeName = resumeName.replace(/'/g, '0011111111111111100');
    }
    formData.append('resumefile', payload.resumefile, resumeName);
    formData.append('resume', resumePayload);
    formData.append('doNotTriggerEvent', 'true');
    const response = await axios.post(
      '/wl-profile-svc/api/user-profile/resume',
      formData,
      {
        headers: { Authorization: `Bearer ${vxm.users.getToken}` },
      },
    );
    return response;
  }

  @action({ mode: 'mutate' })
  public async saveUserProfile(
    { dob, totalFlightHours } = { dob: null, totalFlightHours: '' },
  ) {
    await vxm.users.refreshProfileInfo();
    const userProfile = vxm.users.myUserProfile;
    userProfile.dob = dob || userProfile.dob;
    userProfile.totalFlightHours =
      totalFlightHours || userProfile.totalFlightHours;
    userProfile.notificationTypeMap = {
      ...userProfile.notificationTypeMap,
      MARKETING_EMAIL: this.marketingEmail,
    };
    const response = await vxm.users.saveUserProfile({
      userProfile,
      isPartofRegistration: true,
    });
    return response;
  }

  @action({ mode: 'mutate' })
  public async fetchPilotLicenseCategory() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/licences/category/Pilot',
    );
    this.setPilotLicenseCategories(
      response.data.data.licences.map((opt) => {
        return { text: opt.name, value: opt.masterId };
      }),
    );
  }

  @action({ mode: 'mutate' })
  public async fetchEngineerLicenseCategory() {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/licences/category/Engineer',
    );
    this.setEngineerLicenceCategories(
      response.data.data.licences.map((opt) => {
        return { text: opt.name, value: opt.masterId };
      }),
    );
  }

  @action({ mode: 'mutate' })
  public async saveLicenceInfo(payload) {
    payload.documents = [];
    payload.doNotTriggerEvent = 'true';
    const formData = new FormData();
    formData.append('licenceInfo', JSON.stringify(payload));
    const response = await axios.post(
      '/wl-profile-svc/api/v1/userLicences',
      formData,
      {
        headers: { Authorization: `Bearer ${vxm.users.getToken}` },
      },
    );
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async fetchJobHistoryMetaData() {
    const response = await axios.get(
      `/wl-profile-svc/api/v2/jobHistoryMetaData?companyCode=${
        vxm.jobs.BrandingInfo.companycode
      }`,
    );
    const pilotFleetField = response.data.data.jobHistoryMetaData.find(
      (field) =>
        field.label === 'Fleet' &&
        response.data.data.profiles[0].fields.includes(field.id),
    );
    const engineerFleetField = response.data.data.jobHistoryMetaData.find(
      (field) =>
        field.label === 'Aircraft/Airframe' &&
        response.data.data.profiles[1].fields.includes(field.id),
    );
    const pilotRankField = response.data.data.jobHistoryMetaData.find(
      (field) =>
        field.label === 'Rank' &&
        response.data.data.profiles[0].fields.includes(field.id),
    );
    const engineerRankField = response.data.data.jobHistoryMetaData.find(
      (field) =>
        field.label === 'Rank' &&
        response.data.data.profiles[1].fields.includes(field.id),
    );
    const hourField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'Total Hours on Fleet in Rank',
    );
    const jobRoleField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'What is your job role?',
    );
    const aircraftAirframeField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'Aircraft/Airframe',
    );
    const equipmentTypeField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'Engine Type',
    );
    const lastFlightDateField = response.data.data.jobHistoryMetaData.find(
      (field) => field.label === 'Date of Last Flight',
    );
    const customFieldMapping = {
      rank: pilotRankField.name,
      fleet: pilotFleetField.name,
      hour: hourField.name,
      role: jobRoleField.name,
      aircraftAirframe: aircraftAirframeField.name,
      equipmentType: equipmentTypeField.name,
      lastFlightDate: lastFlightDateField.name,
    };
    this.setPilotRankOptions(
      pilotRankField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setEngineerRankOptions(
      engineerRankField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setPilotFleetOptions(
      pilotFleetField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setEngineerFleetOptions(
      engineerFleetField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setEquipmentTypeOptions(
      equipmentTypeField.displayList.map((opt) => ({ value: opt, text: opt })),
    );
    this.setCustomFieldMappings(customFieldMapping);
  }

  @action({ mode: 'mutate' })
  public async saveJobHistory(payload) {
    payload.doNotTriggerEvent = 'true';
    const response = await axios.post(
      '/wl-profile-svc/api/v1/jobHistory',
      payload,
      {
        headers: { Authorization: `Bearer ${vxm.users.getToken}` },
      },
    );
    return response.data;
  }

  @action({ mode: 'mutate' })
  public async fetchChildCompanies() {
    const response = await axios.post(
      `/wl-jobs-svc/api/v1/jobHistory/company/${
        vxm.jobs.BrandingInfo.companycode
      }`,
    );
    this.setChildCompanies(response.data);
  }

  @action({ mode: 'mutate' })
  public async triggerMegaEvent(payload) {
    const response = await axios.post(
      '/wl-profile-svc/api/user-profile/triggerMegaIntegrationEvent',
      {
        sections: payload,
      },
      {
        headers: { Authorization: `Bearer ${vxm.users.getToken}` },
      },
    );
  }

  @action({ mode: 'mutate' })
  public async megaSignup(payload) {
    try {
      vxm.users.Rudderstack.trackEvent('Custom Role - megasignup event', {
        userDetails: buildMegaSignupUserDetails(payload),
      });
    } catch (error) {
      console.warn('Failed to capture megaSignup analytics payload', error);
    }
    try {
      const response = await axios.post(
        '/wl-profile-svc/api/v2/megaSignup',
        payload,
        {
          headers: {
            Authorization: `Bearer ${vxm.users.getToken}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      if (
        !response.data ||
        !response.data.meta ||
        !response.data.meta.success
      ) {
        this.trackMegaSignupFailure({
          payload,
          error: response.data,
          stage: 'megaSignupApi',
        });
      }
      return response.data;
    } catch (error) {
      this.trackMegaSignupFailure({ payload, error, stage: 'megaSignupApi' });
      throw error;
    }
  }

  @action({ mode: 'mutate' })
  public trackMegaSignupFailure({ payload, error, stage }) {
    try {
      vxm.users.Rudderstack.trackEvent(
        'Custom Role - megasignup event failure',
        {
          userDetails: {
            ...buildMegaSignupUserDetails(payload),
            stage,
            error: serializeMegaSignupError(error),
          },
        },
      );
    } catch (trackError) {
      console.warn(
        'Failed to capture megaSignup failure analytics payload',
        trackError,
      );
    }
  }
}

// vuex-class-component actions run against a store proxy that only exposes
// state/getters/mutations/decorated-actions, so these helpers must live
// outside the class rather than as `this.`-called instance methods.

// Drops any top-level key containing "password" (password, newPassword, oldPassword,
// currentPassword, ...) so credentials never reach the Rudderstack analytics payload.
function stripSensitiveFields(obj: any): any {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  Object.keys(obj).forEach((key) => {
    if (/password/i.test(key)) {
      delete obj[key];
    }
  });
  return obj;
}

// Parses one FormData field in isolation so a missing/malformed field only
// drops itself from the analytics payload instead of blanking out the rest.
function parseFormDataField(value: FormDataEntryValue | null, field: string): any {
  if (typeof value !== 'string') {
    return undefined;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn(`Failed to parse megaSignup ${field} for analytics`, error);
    return undefined;
  }
}

function buildMegaSignupUserDetails(payload): any {
  try {
    if (payload instanceof FormData) {
      const userDetails: any = {};
      const userProfileData = parseFormDataField(
        payload.get('userProfileData'),
        'userProfileData',
      );
      if (userProfileData !== undefined) {
        userDetails.userProfileData = stripSensitiveFields(userProfileData);
      }
      const licenceData = parseFormDataField(
        payload.get('licenceData'),
        'licenceData',
      );
      if (licenceData !== undefined) {
        userDetails.licenceData = licenceData;
      }
      const jobHistoryData = parseFormDataField(
        payload.get('jobHistoryData'),
        'jobHistoryData',
      );
      if (jobHistoryData !== undefined) {
        userDetails.jobHistoryData = jobHistoryData;
      }
      const passportData = parseFormDataField(
        payload.get('passportData'),
        'passportData',
      );
      if (passportData !== undefined) {
        userDetails.passportData = passportData;
      }
      return userDetails;
    }
    if (payload && typeof payload === 'object') {
      // Strips non-serializable members (functions, Vue reactivity getters) via a JSON round-trip.
      const sanitized = JSON.parse(JSON.stringify(payload));
      return stripSensitiveFields(sanitized);
    }
  } catch (error) {
    console.warn('Failed to build megaSignup userDetails payload', error);
  }
  return {};
}

function serializeMegaSignupError(error): any {
  if (!error) {
    return { message: 'Unknown megaSignup error' };
  }
  if (error.message || error.response || error.request) {
    const serialized: any = {
      message: error.message || 'megaSignup request failed',
    };
    if (error.response) {
      serialized.status = error.response.status;
      serialized.statusText = error.response.statusText;
      serialized.data = error.response.data;
    } else if (error.request) {
      serialized.status = 'no_response';
    }
    if (error.code) {
      serialized.code = error.code;
    }
    return serialized;
  }
  return { meta: error.meta, data: error.data };
}
